
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { formatDate, formatTime } from '@/core';

import { Booking } from '../interfaces';

import BaseBooking from './BaseBooking.vue';

@Component
export default class CancelBooking extends BaseBooking {
  @Action('reset', { namespace: 'booking' }) reset!: () => void;

  @Action('cancelBooking', { namespace: 'booking' }) cancelBooking!: (id: string) => void;

  @Getter('error', { namespace: 'booking' }) error!: boolean;

  @Getter('errorMessage', { namespace: 'booking' }) errorMessage!: string;

  @Getter('loading', { namespace: 'booking' }) loading!: boolean;

  @Getter('response', { namespace: 'booking' }) response!: boolean;

  @Getter('currentBooking', { namespace: 'booking' }) currentBooking!: Booking | null;



  @Watch('$store.state.booking.error')
  bookingNotFound(): void {
    if (!this.currentBooking) {
      this.$router.replace(`/${this.$route.params.slug}`);
      // console.log('booking non trouvée');
      this.reset();
    }
  }

  updateBookingList() {
    this.getBookingList(this.email)
  }



  getFormatDate = function getFormatDate(date: string): string {
    return formatDate(date);
  };

  getFormatTime = function getFormatDate(date: string): string {
    return formatTime(date);
  };

  onCancelBooking(): void {
    if (this.currentBooking && this.currentBooking._id) {
      this.cancelBooking(this.currentBooking._id);
    }
  }

  goBooking(): void {
    if (this.$route.name !== 'multipleBooking') {
      this.$router.replace({ name: this.routes.multipleBooking, params: { slug: this.$route.params.slug } });
    }

  }
}
